(function () {
  var ACTIVE = 'oddit-section-pdp-timeline__card--active';
  var UPCOMING = 'oddit-section-pdp-timeline__card--upcoming';
  var DOT_ACTIVE = 'oddit-section-pdp-timeline__dot--active';
  var MEASURING = 'oddit-section-pdp-timeline--measuring';
  var TRANSITION_MS = 300;
  var RELEASE_MS = 420;
  var SETTLE_MS = 90;

  var hasScrollEnd = 'onscrollend' in window;

  function bezier(p1x, p1y, p2x, p2y) {
    function a(x1, x2) { return 1 - 3 * x2 + 3 * x1; }
    function b(x1, x2) { return 3 * x2 - 6 * x1; }
    function c(x1) { return 3 * x1; }
    function at(t, x1, x2) { return ((a(x1, x2) * t + b(x1, x2)) * t + c(x1)) * t; }
    function slope(t, x1, x2) { return 3 * a(x1, x2) * t * t + 2 * b(x1, x2) * t + c(x1); }
    return function (x) {
      if (x <= 0) return 0;
      if (x >= 1) return 1;
      var t = x;
      for (var i = 0; i < 6; i++) {
        var s = slope(t, p1x, p2x);
        if (!s) break;
        t -= (at(t, p1x, p2x) - x) / s;
      }
      return at(t, p1y, p2y);
    };
  }

  var EASE = bezier(0.4, 0, 0.2, 1);

  function init(container) {
    var section = container || document.querySelector('.oddit-section-pdp-timeline');
    if (!section) return;
    if (section._odditTimelineInit) return;
    section._odditTimelineInit = true;

    var track = section.querySelector('.oddit-section-pdp-timeline__cards');
    var cards = section.querySelectorAll('.oddit-section-pdp-timeline__card');
    var dots = section.querySelectorAll('.oddit-section-pdp-timeline__dot');
    if (!cards.length) return;

    var active = 0;
    cards.forEach(function (card, i) {
      if (card.classList.contains(ACTIVE)) active = i;
    });

    var base = 0;
    var stops = [];

    function scrollable() {
      return !!track && track.scrollWidth - track.clientWidth > 1;
    }

    function maxScrollLeft() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function measure() {
      if (!track) return;
      base = cards[0].offsetLeft;
      stops = [];
      cards.forEach(function (card) {
        stops.push(card.offsetLeft - base);
      });
    }

    function finalStop(index) {
      var shift = index > active ? cards[active].offsetWidth - cards[index].offsetWidth : 0;
      return Math.min(Math.max(stops[index] - shift, 0), maxScrollLeft());
    }

    function indexAt(scrollLeft) {
      if (!stops.length) measure();
      var max = maxScrollLeft();
      var best = 0;
      var bestGap = Infinity;
      for (var i = 0; i < stops.length; i++) {
        var gap = Math.abs(Math.min(stops[i], max) - scrollLeft);
        if (gap < bestGap) {
          bestGap = gap;
          best = i;
        }
      }
      return best;
    }

    function setDots(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle(DOT_ACTIVE, i === index);
      });
    }

    function setActive(index) {
      active = index;
      cards.forEach(function (card, i) {
        var on = i === index;
        card.classList.toggle(ACTIVE, on);
        card.classList.toggle(UPCOMING, !on);
        card.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      setDots(index);
    }

    var pinFrame = null;
    var releaseTimer = null;

    function unpin() {
      if (pinFrame) cancelAnimationFrame(pinFrame);
      pinFrame = null;
    }

    function release() {
      unpin();
      clearTimeout(releaseTimer);
      releaseTimer = null;
      if (track) track.style.removeProperty('scroll-snap-type');
      measure();
    }

    function hold() {
      unpin();
      clearTimeout(releaseTimer);
      releaseTimer = null;
      if (track) track.style.scrollSnapType = 'none';
    }

    function glide(to) {
      var from = track.scrollLeft;
      hold();
      releaseTimer = setTimeout(release, RELEASE_MS);
      if (Math.abs(to - from) < 1) return;

      var start = null;
      function step(now) {
        if (start === null) start = now;
        var p = (now - start) / TRANSITION_MS;
        if (p > 1) p = 1;
        track.scrollLeft = from + (to - from) * EASE(p);
        if (p < 1) {
          pinFrame = requestAnimationFrame(step);
        } else {
          pinFrame = null;
          release();
        }
      }
      pinFrame = requestAnimationFrame(step);
    }

    function reserveTrackHeight() {
      if (!track) return;

      var restore = [];
      cards.forEach(function (card) {
        restore.push(card.classList.contains(ACTIVE));
      });

      // Drop the previous floor before measuring, or each pass reads back the last
      // result instead of the card's own height.
      section.style.removeProperty('--oddit-pdp-timeline-cards-h');
      section.classList.add(MEASURING);

      var tallest = 0;
      cards.forEach(function (_, index) {
        cards.forEach(function (card, i) {
          card.classList.toggle(ACTIVE, i === index);
          card.classList.toggle(UPCOMING, i !== index);
        });
        tallest = Math.max(tallest, track.getBoundingClientRect().height);
      });

      cards.forEach(function (card, i) {
        card.classList.toggle(ACTIVE, restore[i]);
        card.classList.toggle(UPCOMING, !restore[i]);
      });

      if (tallest) section.style.setProperty('--oddit-pdp-timeline-cards-h', Math.ceil(tallest) + 'px');
      void track.offsetWidth;
      section.classList.remove(MEASURING);
      measure();
    }

    var scrollFrame = null;
    var endTimer = null;

    function onScrollFrame() {
      scrollFrame = null;
      if (!scrollable()) return;
      setDots(indexAt(track.scrollLeft));
    }

    function onScroll() {
      if (pinFrame) return;
      if (!scrollFrame) scrollFrame = requestAnimationFrame(onScrollFrame);
      if (!hasScrollEnd) {
        clearTimeout(endTimer);
        endTimer = setTimeout(onScrollEnd, SETTLE_MS);
      }
    }

    function onScrollEnd() {
      if (pinFrame || releaseTimer) return;
      if (!scrollable()) return;
      measure();
      var index = indexAt(track.scrollLeft);
      if (index > active + 1) index = active + 1;
      if (index < active - 1) index = active - 1;
      if (index === active) {
        setDots(index);
        return;
      }
      var to = finalStop(index);
      setActive(index);
      glide(to);
    }

    function onPointerDown() {
      unpin();
    }

    function select(index) {
      if (index === active) return;

      if (!scrollable()) {
        setActive(index);
        measure();
        return;
      }

      measure();

      var to = finalStop(index);
      setActive(index);
      glide(to);
    }

    function onClick(i) {
      return function () { select(i); };
    }

    function onKeydown(i) {
      return function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        select(i);
      };
    }

    var clickHandlers = [];
    var keydownHandlers = [];
    cards.forEach(function (card, i) {
      var ch = onClick(i);
      var kh = onKeydown(i);
      clickHandlers.push(ch);
      keydownHandlers.push(kh);
      card.addEventListener('click', ch);
      card.addEventListener('keydown', kh);
    });

    if (track) {
      track.addEventListener('scroll', onScroll, { passive: true });
      track.addEventListener('pointerdown', onPointerDown, { passive: true });
      track.addEventListener('touchstart', onPointerDown, { passive: true });
      if (hasScrollEnd) track.addEventListener('scrollend', onScrollEnd);
    }

    reserveTrackHeight();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(reserveTrackHeight);
    }

    var lastWidth = window.innerWidth;
    var remeasure;
    function onResize() {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      release();
      clearTimeout(remeasure);
      remeasure = setTimeout(reserveTrackHeight, 150);
    }
    window.addEventListener('resize', onResize);

    // Store cleanup for theme editor unload
    section._odditTimelineCleanup = function () {
      if (track) {
        track.removeEventListener('scroll', onScroll);
        track.removeEventListener('pointerdown', onPointerDown);
        track.removeEventListener('touchstart', onPointerDown);
        if (hasScrollEnd) track.removeEventListener('scrollend', onScrollEnd);
        track.style.removeProperty('scroll-snap-type');
      }
      window.removeEventListener('resize', onResize);
      unpin();
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      clearTimeout(releaseTimer);
      clearTimeout(endTimer);
      clearTimeout(remeasure);
      section.classList.remove(MEASURING);
      section.style.removeProperty('--oddit-pdp-timeline-cards-h');
      cards.forEach(function (card, i) {
        card.removeEventListener('click', clickHandlers[i]);
        card.removeEventListener('keydown', keydownHandlers[i]);
      });
      delete section._odditTimelineInit;
      delete section._odditTimelineCleanup;
    };
  }

  // Initial page load
  document.querySelectorAll('.oddit-section-pdp-timeline').forEach(function (el) {
    init(el);
  });

  // Theme editor: section reload
  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target.querySelector('.oddit-section-pdp-timeline');
    if (container) init(container);
  });

  // Theme editor: section unload
  document.addEventListener('shopify:section:unload', function (event) {
    var container = event.target.querySelector('.oddit-section-pdp-timeline');
    if (container && container._odditTimelineCleanup) container._odditTimelineCleanup();
  });
})();
